import { Warehouse, Truck } from "@nxt-costco-com/forge-icons";
import { Box } from "@nxt-costco-com/forge-icons/icons/Box";
import { Location } from "@nxt-costco-com/forge-icons/icons/Location";
import { LocationPinFilled } from "@nxt-costco-com/forge-icons/icons/LocationPinFilled";
const COMPONENT_NAME = "DELIVERY_LOCATION_SELECTOR";
const AVAILABLE_ICONS = {
  Box,
  Location,
  LocationPinFilled,
  Truck,
  Warehouse
};
export {
  AVAILABLE_ICONS,
  COMPONENT_NAME
};
